<template>
<div class="h-screen flex w-full bg-img-login vx-row no-gutter items-center justify-center" id="page-login">
  <div class="vx-col w-full md:w-2/3 xl:w-1/2 sm:m-0 m-4">
    <vx-card>
      <div slot="no-body" class="full-page-bg-color">
        <div class="vx-row no-gutter justify-center items-center">
          <div class="vx-col w-full d-theme-dark-bg">
            <RegistrationDone :number="number" v-if="step === 3" />
            <RegistrationQuiz
              v-else-if="step === 2" :phone.sync="phone" :name.sync="name" :ogrn.sync="ogrn"
              :reestr.sync="reestr" :tin.sync="tin" :address.sync="address" :contact.sync="contact"
              :file-ogrn.sync="fileOgrn" :file-register.sync="fileRegister" :file-tin.sync="fileTin"
              @next-step="register"
            />
            <RegistrationPhone v-else @next-step="getData" :phone.sync="phone" />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</div>
</template>

<script>
import RegistrationPhone from '@/views/pages/registration/RegistrationPhone'
import RegistrationQuiz from '@/views/pages/registration/RegistrationQuiz'
import RegistrationDone from '@/views/pages/registration/RegistrationDone'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'registration',
  components: {RegistrationDone, RegistrationPhone, RegistrationQuiz},
  data: () => ({
    step: 1,
    phone: '',
    name: '',
    ogrn: '',
    reestr: '',
    tin: '',
    address: '',
    contact: '',
    fileOgrn: null,
    fileRegister: null,
    fileTin: null,
    number: '8903812'
  }),
  methods: {
    ...mapActions('onboarding', ['sendFiles']),
    getData () {
      this.step = 2
    },
    async register () {
      const form = new FormData()
      form.append('ogrn', this.fileOgrn)
      form.append('register', this.fileRegister)
      form.append('tin', this.fileTin)

      console.log(await this.sendFiles(form))

      //this.step = 3
    }
  },
  computed: {
    ...mapGetters('onboarding', ['formData'])
  }
}
</script>

<style scoped>

</style>
